module.exports = __webpack_public_path__ + "static/media/umerdoctor1-2.814f25d5.png";